import { useEffect, useState, type ReactNode } from "react";
import { SharedChatProvider, normalizeSharedChatTheme, type SharedChatThemeName } from "@sudowrite/shared-chat";

function readBodyTheme(): SharedChatThemeName {
  if (typeof document === "undefined") return "light";
  return normalizeSharedChatTheme(document.body.getAttribute("data-theme"));
}

export function SharedChatThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<SharedChatThemeName>(readBodyTheme);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const syncTheme = () => setTheme(readBodyTheme());
    syncTheme();

    const observer = new MutationObserver(syncTheme);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-theme-type", "data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return <SharedChatProvider theme={theme}>{children}</SharedChatProvider>;
}
